module.exports = __webpack_public_path__ + "img/AI资源库.4ec95c43.png";